import React from 'react';
import Image from '3-components/Image/Image';

interface AuthorProps {
    authorImgSrc: string;
    authorName: string;
    authorRole: string
}

const Author = ({ authorImgSrc, authorName, authorRole }: AuthorProps) => {
    if (!authorName) {
        return null;
    }

    return (
        <div className="author-component">
            {authorImgSrc && (
                <Image
                    imgSrc={authorImgSrc}
                    imgAlt="author name"
                    aspectRatio="1/1"
                    imgCustomClass="author-avatar"
                />
            )}
            <div className="author-info">
                <div className="author-name">
                    {authorName}
                </div>
                <div className="author-role">
                    {authorRole}
                </div>
            </div>
        </div>
    );
};

export default Author;
